import { Box, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import EmptyTableRow from 'src/Component/EmptyTableRow'
import PaginatedTable, { HeadCellI, SortOrderI } from 'src/Component/PaginatedTable'
import SearchInput from 'src/Component/SearchInput'

import DataRow from './DataRow'
import { useApproveWalletRequestMutation, useGetWalletRequestsQuery } from 'src/api/membershipApi'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import { errorToast } from 'src/utils/toastService'

const headCells: HeadCellI[] = [
  {
    id: 'created_at',
    sortable: true,
    label: 'Requested date',
  },
  {
    id: 'user__name',
    sortable: true,
    label: 'User Name',
  },
  {
    id: 'user__email',
    sortable: true,
    label: 'User Email',
  },

  {
    id: 'user__trainer_category',
    sortable: true,
    label: 'Category',
  },
  {
    id: 'amount',
    sortable: true,
    label: 'Requested Amount',
  },

  {
    id: 'comments',
    sortable: true,
    label: 'Comment',
  },
  {
    id: 'approved',
    sortable: true,
    label: 'Status',
  },
  {
    id: 'id',
    sortable: false,
    label: 'Action',
    align: 'center',
  },
]

const WalletRequests = () => {
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<SortOrderI>('asc')
  const [sortOrderBy, setSortOrderBy] = useState<string>('')

  const dispatch = useDispatch<AppDispatch>()
  const [approvePayment, { isLoading }] = useApproveWalletRequestMutation()

  const {
    data: WALLETREQUESTS_DATA_RESPONSE,
    isFetching,
    refetch,
  } = useGetWalletRequestsQuery(
    {
      search,
      page,
      pageSize: 10,
      sortBy: (() => {
        if (sortOrder === 'asc') {
          return sortOrderBy
        } else {
          return `-${sortOrderBy}`
        }
      })(),
    },
    { refetchOnMountOrArgChange: true },
  )

  const handleSearch = (value: string) => {
    setPage(1)
    setSearch(value)
  }

  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const handleSorting = (_sortOrderBy: string) => {
    setSortOrder((prevState) => {
      return prevState === 'asc' ? 'desc' : 'asc'
    })
    setSortOrderBy(_sortOrderBy)
  }
  const handlePayClick = (uid: string) => {
    approvePayment(uid)
      .unwrap()
      .then((res) => {
        refetch()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to approve payment.')
      })
  }

  useEffect(() => {
    if (isFetching || isLoading) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching, isLoading])

  return (
    <Box className='pageContainer'>
      <Grid container>
        <Grid md={8} sm={12} xs={12}>
          {' '}
        </Grid>
        <Grid md={4} sm={12} xs={12}>
          <Box>
            <SearchInput hasDebounce onChange={handleSearch} />
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid md={4} sm={12} xs={12}>
          <Box mt={2} sx={{ backgroundColor: '#111111', p: 2 }}>
            <Typography variant='h5'>Total Pending Requests</Typography>
            <Typography variant='h2' mt={2}>
              {WALLETREQUESTS_DATA_RESPONSE?.count}
            </Typography>
          </Box>
        </Grid>
        <Grid md={8} sm={12} xs={12}>
          <Box> </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        {WALLETREQUESTS_DATA_RESPONSE && (
          <PaginatedTable
            title='Wallet Request'
            headCells={headCells}
            currentPage={page}
            onPageChange={handlePageChange}
            totalPages={Math.ceil(WALLETREQUESTS_DATA_RESPONSE?.count / 10)}
            onSortClick={handleSorting}
          >
            <>
              {WALLETREQUESTS_DATA_RESPONSE?.results?.length === 0 && (
                <EmptyTableRow cellCount={headCells.length} />
              )}
              {WALLETREQUESTS_DATA_RESPONSE?.results?.map((request) => {
                return (
                  <DataRow
                    uid={request.uid}
                    key={request.uid}
                    id={request.uid}
                    requestedDate={request.created_at}
                    name={`${request?.user?.first_name} ${request?.user?.last_name}`}
                    email={request?.user?.email}
                    isPaid={request.approved}
                    category={request?.user?.trainer_category?.name}
                    requestedAmount={request.amount}
                    comment={request.comments}
                    onPayClick={handlePayClick}
                  />
                )
              })}
            </>
          </PaginatedTable>
        )}
      </Box>
    </Box>
  )
}

export default WalletRequests
